// Generate a secure random string using the browser crypto functions
export function generateRandomString() {
  const array = new Uint32Array(28);

  window.crypto.getRandomValues(array);

  return Array.from(array, (dec) => `0${dec.toString(16)}`.substring(dec.toString(16).length - 2)).join('');
}
